import { render } from "./SectionPortfolio.vue?vue&type=template&id=1e1ca489&ts=true"
import script from "./SectionPortfolio.vue?vue&type=script&lang=ts"
export * from "./SectionPortfolio.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__